import Service from "../AuthService";
const pdf = {
    getOrderPDF(id) {
        return Service.get("/order-pdf/"+id);
    },
    getInvoicePDF(id){
        return Service.get("/invoice-pdf/"+id);
    }
};
export default pdf;
